export const wordTranslations = [
  { no: 'Nabolag', dk: 'Lokalsamfund', sv: 'Lokalsamhälle' },
  { no: 'Naboer', dk: 'Naboer', sv: 'Grannar' },
  { no: 'Nyheter', dk: 'Nyheder', sv: 'Nyheter' },
  { no: 'Vennskap', dk: 'Venskab', sv: 'Vänskap' },
  { no: 'Arrangementer', dk: 'Arrangementer', sv: 'Evenemang' },
];
